"use client";
import { CREDIT_CURRENCIES, isCreditCurrency } from "@/constants/creditPacks";
import {
  loadCreditCatalog,
  type CreditCatalogState,
} from "@/hooks/useCreditCatalog";
import { Button } from "@/components/ui/button";
export function CreditPricingControls({
  catalog,
}: {
  catalog: CreditCatalogState;
}) {
  return (
    <div className="space-y-2 text-xs text-muted-foreground">
      <label className="flex items-center justify-between gap-3">
        <span>Currency</span>
        <select
          aria-label="Credit pack currency"
          value={catalog.currency}
          disabled={catalog.loading}
          className="min-h-11 rounded-md border border-border bg-background px-3 text-foreground"
          onChange={event => {
            if (isCreditCurrency(event.target.value))
              void loadCreditCatalog(event.target.value);
          }}
        >
          {CREDIT_CURRENCIES.map(currency => (
            <option key={currency} value={currency}>
              {currency.toUpperCase()}
            </option>
          ))}
        </select>
      </label>
      {catalog.loading ? (
        <p role="status">Loading prices…</p>
      ) : catalog.error ? (
        <div role="alert">
          <p>{catalog.error}</p>
          <Button
            variant="outline"
            size="sm"
            onClick={() => void loadCreditCatalog()}
          >
            Retry pricing
          </Button>
        </div>
      ) : (
        <p>
          {catalog.region === "international"
            ? "Regional pricing applied: approximately 30% below US prices."
            : "US pricing."}{" "}
          Prices shown in {catalog.currency.toUpperCase()}; any applicable tax
          is shown at checkout.
        </p>
      )}
    </div>
  );
}
